import React from "react";
import style from './Photos.module.css';
import img1 from "./img photo/photo1.jpeg"
import img2 from "./img photo/photo5.jpeg"
import img3 from "./img photo/photo12.jpeg";
import img4 from "./img photo/photo6.jpeg";
import img5 from "./img photo/photo13.jpeg";
import img6 from "./img photo/photo14.jpeg";
import {ReactComponent as Search} from "../../../Redux/icons/search.svg";





const Photos= () => {
    return (
        <div className={style.photosBox}>
            <div className={style.photosHeader}>
                <h5>Photos <span>47</span></h5>
                <form className={style.search}>
                    <input type="search" placeholder="Search Photo" className={style.searchInput}/>
                    <div className={style.wrapBtn}>
                        <div className={style.btnSearch}>
                            <input type="submit" name="" value="" className="submit"/>
                            <Search />
                        </div>
                    </div>
                </form>
            </div>
            <div className={style.photos}>
                <div className={style.photoCard}>
                        <img className={style.photoImg} src={img1} alt={"photo"}/>
                        <div className={style.photoTextOver}>
                            <i className="fa fa-heart"></i>" 57"
                            <div className={style.photoTextOverSpan}>20 hours ago </div>
                        </div>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img2} alt={"photo"}/>
                    <div className={style.photoTextOver}>
                        <a href="#"><i class="fa fa-heart"></i>" 201"</a>
                        <span>20 hours ago </span>
                    </div>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img3} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img4} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img5} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img1} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img2} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img6} alt={"photo"}/>
                </div>
                <div className={style.photoCard}>
                    <img className={style.photoImg} src={img4} alt={"photo"}/>
                </div>


            </div>
        </div>
    )
}

export default Photos;